import { FormGroup, FormControl, Validators } from '@angular/forms';
var Permiso_urbComponent = /** @class */ (function () {
    function Permiso_urbComponent() {
        this.rows = [];
        this.form = new FormGroup({
            permiso_urb1: new FormControl('', Validators.required),
            permiso_urb2: new FormControl('', Validators.required)
        });
        if (!JSON.parse(localStorage.getItem("permiso_urb"))) {
            localStorage.setItem("permiso_urb", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("permiso_urb"));
            this.form.controls['permiso_urb1'].setValue(this.rows[0] ? this.rows[0].Vialidad : 'NO');
            this.form.controls['permiso_urb2'].setValue(this.rows[0] ? this.rows[0].Otros : 'NO');
        }
        this.permiso_urb = { Vialidad: '', Otros: '' };
    }
    Permiso_urbComponent.prototype.add_permiso_urb = function () {
        localStorage.setItem("permiso_urb", JSON.stringify([]));
        this.actualRow = localStorage.getItem("permiso_urb");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            Vialidad: this.form.value.permiso_urb1,
            Otros: this.form.value.permiso_urb2
        });
        localStorage.setItem("permiso_urb", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("permiso_urb")));
    };
    Permiso_urbComponent.prototype.delete_permiso_urb = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permiso_urb", JSON.stringify(this.rows));
            }
        }
    };
    return Permiso_urbComponent;
}());
export { Permiso_urbComponent };
